import { useAppConfig } from '@plato/app-core/hooks/use-app-config';
import { useMemo } from 'react';
import { AuthClient } from '../../utils/auth-client.ts';

/**
 * @deprecated Use useAppConfig instead for accessing app configuration
 */
export function useAcl(): AuthClient {
    const appConfig = useAppConfig();

    return useMemo(() => new AuthClient(appConfig), [appConfig]);
}
